import React, { useState } from 'react';
import './DeleteConfirmationModal.css';

function DeleteConfirmationModal({ 
  isOpen, 
  onClose, 
  onConfirm, 
  itemType, 
  itemName,
  showArchiveOption = true,
  relatedItemsCount = 0
}) {
  const [deleteType, setDeleteType] = useState('archive');

  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm(deleteType);
    onClose();
  };

  return (
    <div className="delete-modal-overlay" onClick={onClose}>
      <div className="delete-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="delete-modal-header">
          <h2>⚠️ Delete {itemType}</h2>
        </div>

        <div className="delete-modal-body">
          <p className="delete-item-name">
            <strong>{itemName}</strong>
          </p>

          {relatedItemsCount > 0 && (
            <div className="related-items-warning">
              <span className="warning-icon">📊</span>
              <span>
                This {itemType.toLowerCase()} has <strong>{relatedItemsCount} transaction{relatedItemsCount !== 1 ? 's' : ''}</strong>
              </span>
            </div>
          )}

          {showArchiveOption ? (
            <>
              <p className="delete-question">How would you like to proceed?</p>

              <div className="delete-options">
                <label className={`delete-option ${deleteType === 'archive' ? 'selected' : ''}`}>
                  <input
                    type="radio"
                    name="deleteType"
                    value="archive"
                    checked={deleteType === 'archive'}
                    onChange={(e) => setDeleteType(e.target.value)}
                  />
                  <div className="option-content">
                    <div className="option-header">
                      <span className="option-icon">📦</span>
                      <span className="option-title">Archive</span>
                      <span className="option-badge recommended">Recommended</span>
                    </div>
                    <p className="option-description">
                      Hide this {itemType.toLowerCase()} but keep all transaction history.
                      Can be restored later from the "Deleted" tab.
                    </p>
                    <ul className="option-features">
                      <li>✅ Keeps all transaction history</li>
                      <li>✅ Can be recovered later</li>
                      <li>✅ Safe option</li>
                    </ul>
                  </div>
                </label>

                <label className={`delete-option danger ${deleteType === 'permanent' ? 'selected' : ''}`}>
                  <input
                    type="radio"
                    name="deleteType"
                    value="permanent"
                    checked={deleteType === 'permanent'}
                    onChange={(e) => setDeleteType(e.target.value)}
                  />
                  <div className="option-content">
                    <div className="option-header">
                      <span className="option-icon">🗑️</span>
                      <span className="option-title">Delete Permanently</span>
                      <span className="option-badge danger">Cannot Undo</span>
                    </div>
                    <p className="option-description">
                      Permanently remove this {itemType.toLowerCase()} and ALL associated transactions.
                      This action cannot be undone!
                    </p>
                    <ul className="option-features">
                      <li>❌ Deletes all {relatedItemsCount} transaction{relatedItemsCount !== 1 ? 's' : ''}</li>
                      <li>❌ Cannot be recovered</li>
                      <li>❌ Permanent action</li>
                    </ul>
                  </div>
                </label>
              </div>
            </>
          ) : (
            <div className="permanent-delete-warning">
              <div className="warning-box">
                <span className="warning-icon">⚠️</span>
                <div>
                  <strong>This will permanently delete this {itemType.toLowerCase()}.</strong>
                  <p>This action cannot be undone.</p>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="delete-modal-footer">
          <button 
            className="cancel-btn" 
            onClick={onClose}
          >
            Cancel
          </button>
          <button 
            className={`confirm-btn ${deleteType === 'permanent' ? 'danger' : 'warning'}`}
            onClick={handleConfirm}
          >
            {deleteType === 'permanent' ? '🗑️ Delete Permanently' : '📦 Archive'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteConfirmationModal;
